// extracted by mini-css-extract-plugin
export default {"container":"SY-z","list":"TY-z"};